import type { JSX } from "react";
import type { WidgetBlock as WidgetBlockModel } from "@shared/types";
import type { BlockRendererProps } from "./registry";
import { WidgetRenderer } from "../WidgetRenderer";

/**
 * widget block renderer (plan B — open-ended generative UI inside the answer
 * framework). Reuses the show_widget `WidgetRenderer` (sandboxed iframe + the
 * host sendPrompt bridge), so 图文 / interactive content emitted via `respond`
 * renders exactly like the legacy show_widget did, but as one block among the
 * structured answer.
 */
export function WidgetBlockView({ block, onSendPrompt }: BlockRendererProps): JSX.Element {
  const w = block as WidgetBlockModel;
  return (
    <div className="widget-card">
      {w.title !== undefined && w.title.length > 0 && <div className="widget-card-head">{w.title}</div>}
      <WidgetRenderer
        html={w.html}
        onSendPrompt={onSendPrompt}
        {...(w.title !== undefined && w.title.length > 0 ? { title: w.title } : {})}
      />
    </div>
  );
}
